import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import Networking from "../components/Networking";
import Portfolio from "../components/Portfolio";
import WhyUs from "../components/WhyUs";

export default function Home() {
  return (
    <>
      <Hero />
      <About />
      <Services />
      <Networking />
      <Portfolio />
      <WhyUs />
    </>
  );
}
